import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantBeneficiary = {
  namespaced: true,

  state: () => ({
    bulkMerchantBeneficiaries: {
      data: [],
      totalRecords: 0
    },
    bulkMerchantBeneficiary: null,
    merchantBeneficiariesInBulk: {
      data: [],
      totalRecords: 0
    },
    // -------------------------------------------------
    merchantBeneficiaries: {
      data: [],
      totalRecords: 0
    },
    merchantBeneficiary: null
  }),

  getters: {
    _bulkMerchantBeneficiaries: state => state.bulkMerchantBeneficiaries,
    _bulkMerchantBeneficiary: state => state.bulkMerchantBeneficiary,
    _merchantBeneficiariesInBulk: state => state.merchantBeneficiariesInBulk,
    // -------------------------------------------------------------------------
    _merchantBeneficiaries: state => state.merchantBeneficiaries,
    _merchantBeneficiary: state => state.merchantBeneficiary
  },

  mutations: {
    BULK_MERCHANT_BENEFICIARIES (state, { totalRecords, data }) {
      state.bulkMerchantBeneficiaries.totalRecords = parseInt(totalRecords)
      state.bulkMerchantBeneficiaries.data = data
    },
    BULK_MERCHANT_BENEFICIARY (state, data) {
      state.bulkMerchantBeneficiary = data
    },
    MERCHANT_BENEFICIARIES_IN_BULK (state, { totalRecords, data }) {
      state.merchantBeneficiariesInBulk.totalRecords = parseInt(totalRecords)
      state.merchantBeneficiariesInBulk.data = data
    },
    // -----------------------------------------------------------------------
    MERCHANT_BENEFICIARIES (state, { totalRecords, data }) {
      state.merchantBeneficiaries.totalRecords = parseInt(totalRecords)
      state.merchantBeneficiaries.data = data
    },
    MERCHANT_BENEFICIARY (state, data) {
      state.merchantBeneficiary = data
    }
  },

  actions: {
    CreateMerchantBeneficiaryBulk ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBeneficiary/CreateMerchantBeneficiaryBulk', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantBeneficiaryBulk ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api.post(`/MerchantBeneficiary/DeleteMerchantBeneficiaryBulk?MerchantBeneficiaryBulkId=${data.merchantBeneficiaryBulkId}&Comment=${data.comment}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DownloadMerchantBeneficiaryBulk ({ rootState, dispatch }, { merchantBeneficiaryBulkId, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api({
          url: `/MerchantBeneficiary/DownloadMerchantBeneficiaryBulk?MerchantBeneficiaryBulkId=${merchantBeneficiaryBulkId}`,
          method: 'GET',
          responseType: 'blob', // file type to be returned
          headers: config.headers
        })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            rootState.loading = false

            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DownloadBulkBeneficiariesByStatus ({ rootState, dispatch }, { merchantBeneficiaryBulkId, avsStatus, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api({
          url: `/MerchantBeneficiary/DownloadBulkBeneficiariesByStatus?MerchantBeneficiaryBulkId=${merchantBeneficiaryBulkId}&AvsStatus=${avsStatus}`,
          method: 'GET',
          responseType: 'blob', // file type to be returned
          headers: config.headers
        })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            rootState.loading = false

            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    AddMerchantBeneficiaryToBulk ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBeneficiary/AddMerchantBeneficiaryToBulk', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // token expired(unauthorized user)
            if (response?.responseCode === 4 || response?.responseCode === '04') {
              dispatch('users/UnauthorizedUser')
            }
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetMerchantBeneficiaryBulk ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantBeneficiary/GetMerchantBeneficiaryBulk?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              // dispatch('users/Logout')
              dispatch('Logout')
                .then(() => window.location.assign('/login'))
                .catch(error => {
                  reject(error)
                })
            } else {
              reject(error)
            }
          })
      })
    },
    GetByIdMerchantBeneficiaryBulk ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantBeneficiary/GetByIdMerchantBeneficiaryBulk?MerchantBeneficiaryBulkId=${payload.merchantBeneficiaryBulkId}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantBeneficiaryBulkDetails ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantBeneficiary/GetMerchantBeneficiaryBulkDetails?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&ProcessingStatus=${paginationParams.processingStatus}&MerchantBeneficiaryBulkId=${paginationParams.merchantBeneficiaryBulkId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              // dispatch('users/Logout')
              dispatch('Logout')
                .then(() => window.location.assign('/login'))
                .catch(error => {
                  reject(error)
                })
            } else {
              reject(error)
            }
          })
      })
    },

    // -----------------------------------------------------------------------
    CreateMerchantBeneficiary ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBeneficiary/CreateMerchantBeneficiary', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            if ([0, '0', '00'].includes(response?.responseCode)) {
              // check response data
              if (response.data) {
                store.commit('merchantBeneficiary/MERCHANT_BENEFICIARIES', {
                  totalRecords: response?.totalRecords,
                  data: response?.data
                })
              }
            }
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantBeneficiary ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBeneficiary/UpdateMerchantBeneficiary', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // token expired(unauthorized user)
            if (response?.responseCode === 4 || response?.responseCode === '04') {
              dispatch('users/UnauthorizedUser')
            }
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantBeneficiary ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true

        api.post(`/MerchantBeneficiary/DeleteMerchantBeneficiary?MerchantBeneficiaryId=${data.merchantBeneficiaryId}&Comment=${data.comment}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              // rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              // rootState.loading = false
              reject(error)
            }
          })
      })
    },
    SwapMerchantBeneficiary ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        api.post('/MerchantBeneficiary/SwapMerchantBeneficiary', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    RequeryMerchantBeneficiary ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        api.post('/MerchantBeneficiary/RequeryMerchantBeneficiary', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },

    GetMerchantBeneficiary ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantBeneficiary/GetMerchantBeneficiary?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              // dispatch('users/Logout')
              dispatch('Logout')
                .then(() => window.location.assign('/login'))
                .catch(error => {
                  reject(error)
                })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantBeneficiaryByID ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantBeneficiary/GetMerchantBeneficiaryByID?merchantbeneficiaryID=${payload.merchantbeneficiaryID}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantBeneficiary
